module.exports = __webpack_public_path__ + "2fd9269e1ff2c3410ec1329e874222a3.svg";